import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "writeoff-item-sheet" }
const _hoisted_2 = { class: "form-row align-items-end" }
const _hoisted_3 = { class: "col-12 col-sm-2 col-lg-1" }
const _hoisted_4 = { class: "col-12 col-sm-10 col-lg-11" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-row" }
const _hoisted_12 = { class: "col-6 col-md-3" }
const _hoisted_13 = { class: "col-6 col-md-3" }
const _hoisted_14 = { class: "col-6 col-md-3" }
const _hoisted_15 = { class: "col-6 col-md-3" }
const _hoisted_16 = { class: "form-row mb-0" }
const _hoisted_17 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DBEdit = _resolveComponent("DBEdit")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DBForm = _resolveComponent("DBForm")!

  return (_openBlock(), _createBlock(_component_DBForm, {
    store: _ctx.store,
    config: _ctx.settings,
    data: _ctx.data,
    ref: "form"
  }, {
    default: _withCtx((formSlot) => [
      _createVNode(_component_Card, {
        panelFun: _ctx.controller.panelFun.value,
        panel: _ctx.panel.key
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-muted small mb-3" }, " Выберите партию по карточке М-17 на складе из шапки акта, при необходимости скорректируйте количество. ", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "position_number"
                }, null, 8, ["form"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "medicament_stock_id",
                  typeahead: "",
                  clear: ""
                }, null, 8, ["form"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "product_name"
                }, null, 8, ["form"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "batch_number"
                }, null, 8, ["form"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "expiry_date"
                }, null, 8, ["form"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "manufacturer"
                }, null, 8, ["form"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "unit_id"
                }, null, 8, ["form"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "_stock_balance"
                }, null, 8, ["form"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "quantity_packages"
                }, null, 8, ["form"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "line_amount"
                }, null, 8, ["form"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_DBEdit, {
                  form: formSlot,
                  field: "journal_ref"
                }, null, 8, ["form"])
              ])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["panelFun", "panel"])
    ]),
    _: 1
  }, 8, ["store", "config", "data"]))
}